/** Shared with BasicTheme — keep values in sync if you change reader behavior. */
export const READER_FONT_SCALE_MIN = 0.85;
export const READER_FONT_SCALE_MAX = 1.5;
export const READER_FONT_BASE_PX = 16;
export const READER_FONT_STORAGE_KEY = 'poppyruz_reader_font_scale';

/** Enhanced spread — matches `BasicTheme` / `ENHANCED_PAGE_BASE`. */
export const ENHANCED_PAGE_BASE = 650;
export const READING_LAMP_STORAGE_KEY = 'poppyruz_reading_lamp_on';
/** Pitch-black background theme id (same as BasicTheme). */
export const PITCH_BLACK_THEME_ID = 'THEME0000014';
